import pigletDeliveryApi from "@/api/piglet/pigletDeliveryApi";

export default {
  namespaced: true,
  states: {

  },
  mutations: {

  },
  actions: {
    async complete({dispatch}, form) {
      try {
        const response = await pigletDeliveryApi.complete(form);
        dispatch('NOTIFY_MSG', 'piglet.notification.complete',
          { root: true});
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, { root: true});
        return await Promise.reject(error);
      }
    },
    async fetchById(_, {id}) {
      try {
        const response = await pigletDeliveryApi.fetchById(id);
        return Promise.resolve(response.data)
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    async isDuplicate(_, {producerId, deliveryDate}) {
      try {
        const response = await pigletDeliveryApi.isDuplicate(producerId, deliveryDate);
        return Promise.resolve(response.data)
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    async printById(_, {id, context}) {
      try {
        const response = await pigletDeliveryApi.printById(id, context);
        return Promise.resolve(response.data)
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    async remove({dispatch}, {id}) {
      try {
        await pigletDeliveryApi.remove(id);

        return Promise.resolve()
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, { root: true});
        return await Promise.reject(error);
      }
    },
    async removeMulti({dispatch}, idsToDelete) {
      try {
        await pigletDeliveryApi.removeMulti(idsToDelete);
        return Promise.resolve()
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, { root: true});
        return await Promise.reject(error);
      }
    },
    async cancel({dispatch}, storageIds) {
      try {
        await pigletDeliveryApi.cancel(storageIds);
        return Promise.resolve()
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, { root: true});
        return await Promise.reject(error);
      }
    },
    async reOpen({dispatch}, storageIds) {
      try {
        await pigletDeliveryApi.reOpen(storageIds);
        dispatch('NOTIFY_MSG', 'piglet.notification.reOpen',
          { root: true});
        return Promise.resolve()
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, { root: true});
        return await Promise.reject(error);
      }
    },
    async save({dispatch}, form) {
      try {
        const response = await pigletDeliveryApi.save(form);
        dispatch('NOTIFY_MSG', 'piglet.notification.save',
          { root: true});
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, { root: true});
        return await Promise.reject(error);
      }
    }
  }
}
